<app-fullscreen-error 
  [visible]="(hasError$ | async) === true" 
  [message]="'profile.error.defaultMessage' | translate"
  (onRefresh)="retry()">
</app-fullscreen-error>

<app-header-title [title]="'profile.title' | translate" />

<div class="mx-2 my-4">
  <div *ngIf="(loading$ | async)" class="flex justify-center items-center py-12">
    <p-progressSpinner styleClass="w-16 h-16" strokeWidth="4"></p-progressSpinner>
  </div>

  <div *ngIf="(loading$ | async) === false && (hasError$ | async) === false" class="grid grid-cols-1 xl:grid-cols-2 gap-4">
    <!-- Edycja profilu -->
    <div class="bg-darkwhite dark:bg-gray-800 dark:text-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow"
         *ngIf="getAccountType() === 'COMPANY'">
      <app-edit-company-profile-card [companyProfile]="profile$ | async"></app-edit-company-profile-card>
    </div>

    <!-- Zmiana hasła -->
    <div class="bg-darkwhite dark:bg-gray-800 dark:text-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow"
         *ngIf="getAccountType()">
      <app-edit-password-card></app-edit-password-card>
    </div>

    <!-- Lista pakietów - zajmuje pełną szerokość -->
    <div class="bg-darkwhite dark:bg-gray-800 dark:text-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow xl:col-span-2"
         *ngIf="getAccountType() === 'COMPANY'">
      <app-profile-packages-list [packages]="(profile$ | async)?.packages"></app-profile-packages-list>
    </div>
  </div>
</div>
